import { render, staticRenderFns } from "./ListCenter.vue?vue&type=template&id=72ab697d"
import script from "./ListCenter.vue?vue&type=script&lang=js"
export * from "./ListCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports